module.exports = __webpack_public_path__ + "static/media/project_cases_ilustracoes.065b5997.jpg";